import { StyleSheet } from 'react-native'
import type { Theme } from '../../src/theme/getTheme'

export function getLandingMarketingImpersonationBannerStyles(theme: Theme) {
  return StyleSheet.create({
    wrap: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      paddingVertical: 10,
      paddingHorizontal: theme.spacing.lg,
      backgroundColor: theme.background.shell,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    text: {
      flex: 1,
      ...theme.typography.caption,
      color: theme.gray[500],
    },
    exitBtn: {
      paddingVertical: 8,
      paddingHorizontal: theme.spacing.md,
      borderRadius: theme.borderRadius.sm,
      backgroundColor: theme.primaryDark,
    },
    exitBtnPressed: {
      opacity: 0.88,
    },
    exitBtnText: {
      ...theme.typography.labelSmall,
      color: theme.white,
    },
  })
}
